import { FC } from 'react';
import { Container, TooltipContent } from './Tooltip.styles';
import { TooltipProps } from './Tooltip.types';

export const Tooltip: FC<TooltipProps> = ({ children, id, text }) => {
  return (
    <Container aria-describedby={id}>
      <TooltipContent role="tooltip" id={id}>
        {text}
      </TooltipContent>
      {children}
    </Container>
  );
};
